import { AmbienteEnviado } from 'ambiente';
import { menuVip } from './res';

const generateObjectRes = () => {
  switch (AmbienteEnviado.toString()) {
    case 'menuVip':
      return menuVip.getObject();
    default:
      return menuVip.getObject();
  }
};

const res = generateObjectRes();

export const useResources = () => {
  return res;
};
